"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
const VolumeOff = props => {
  const {
    fontsize,
    themeColor,
    ...rest
  } = props;
  const theme = _react.default.useContext(_styledComponents.ThemeContext);
  const {
    sizeStyles,
    colorStyles
  } = (0, _inline_svg.parseStyles)({
    fontsize,
    themeColor
  }, theme);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    fillRule: "evenodd",
    clipRule: "evenodd"
    // eslint-disable-next-line max-len
    ,

    d: "M2.93005 4.34L4.34005 2.93L21.0701 19.65L19.6601 21.06L17.6101 19.01C16.5701 19.84 15.3401 20.46 14.0001 20.76V18.7C14.8001 18.47 15.5301 18.08 16.1801 17.59L12.0001 13.41V20L7.00005 15H3.00005V9H7.00005L7.29005 8.7L2.93005 4.34ZM18.5901 14.34C18.8501 13.61 19.0001 12.82 19.0001 12C19.0001 8.83 16.8901 6.15 14.0001 5.29V3.23C18.0101 4.14 21.0001 7.72 21.0001 12C21.0001 13.39 20.6801 14.7 20.1201 15.87L18.5901 14.34ZM12.0001 4L10.1201 5.88L12.0001 7.76V4ZM14.0001 7.97C15.4801 8.71 16.5001 10.23 16.5001 12C16.5001 12.08 16.4901 12.16 16.4801 12.24L14.0001 9.76V7.97Z",
    fill: "#75767A"
  }, colorStyles)));
};
VolumeOff.propTypes = _inline_svg2.default.propTypes;
VolumeOff.defaultProps = _inline_svg2.default.defaultProps;
var _default = exports.default = VolumeOff;